/* tslint:disable */
/* eslint-disable */
/**
 * Venue Loyalty API
 * Onyx Gaming Venue Loyalty API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated.
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  AddNote200Response,
  AddNoteRequestContent,
  BadRequestErrorResponseContent,
  CreatePlayer200Response,
  CreatePlayerMobile200Response,
  CreatePlayerMobileRequestContent,
  CreatePlayerRequestContent,
  DecrementLoyaltyPointsRequestContent,
  DeleteNote200Response,
  GenericSuccessResponseContent,
  GetBilling200Response,
  GetBilling404Response,
  GetLoyaltyPoints200Response,
  GetNotes200Response,
  GetPasLastViewed200Response,
  GetPlayerActivityStatement200Response,
  GetPlayerDetails200Response,
  IncrementLoyaltyPointsRequestContent,
  InternalFailureErrorResponseContent,
  ListLoyaltyPromotions200Response,
  ListPlayerActivity200Response,
  ListPlayerActivitySummary200Response,
  Login200Response,
  LoginRefresh200Response,
  LoginRefreshRequestContent,
  LoginRequestContent,
  NotAuthorizedErrorResponseContent,
  SearchPlayer200Response,
  SearchPlayerEmail200Response,
  SearchPlayerEmailRequestContent,
  SearchPlayerMobile200Response,
  SearchPlayerMobileRequestContent,
  SearchPlayerRequestContent,
  SetLoyaltyPointsRequestContent,
  SetPasLastViewed200Response,
  SetPlayerDetailsRequestContent,
} from '../models';
import {
    AddNote200ResponseFromJSON,
    AddNote200ResponseToJSON,
    AddNoteRequestContentFromJSON,
    AddNoteRequestContentToJSON,
    BadRequestErrorResponseContentFromJSON,
    BadRequestErrorResponseContentToJSON,
    CreatePlayer200ResponseFromJSON,
    CreatePlayer200ResponseToJSON,
    CreatePlayerMobile200ResponseFromJSON,
    CreatePlayerMobile200ResponseToJSON,
    CreatePlayerMobileRequestContentFromJSON,
    CreatePlayerMobileRequestContentToJSON,
    CreatePlayerRequestContentFromJSON,
    CreatePlayerRequestContentToJSON,
    DecrementLoyaltyPointsRequestContentFromJSON,
    DecrementLoyaltyPointsRequestContentToJSON,
    DeleteNote200ResponseFromJSON,
    DeleteNote200ResponseToJSON,
    GenericSuccessResponseContentFromJSON,
    GenericSuccessResponseContentToJSON,
    GetBilling200ResponseFromJSON,
    GetBilling200ResponseToJSON,
    GetBilling404ResponseFromJSON,
    GetBilling404ResponseToJSON,
    GetLoyaltyPoints200ResponseFromJSON,
    GetLoyaltyPoints200ResponseToJSON,
    GetNotes200ResponseFromJSON,
    GetNotes200ResponseToJSON,
    GetPasLastViewed200ResponseFromJSON,
    GetPasLastViewed200ResponseToJSON,
    GetPlayerActivityStatement200ResponseFromJSON,
    GetPlayerActivityStatement200ResponseToJSON,
    GetPlayerDetails200ResponseFromJSON,
    GetPlayerDetails200ResponseToJSON,
    IncrementLoyaltyPointsRequestContentFromJSON,
    IncrementLoyaltyPointsRequestContentToJSON,
    InternalFailureErrorResponseContentFromJSON,
    InternalFailureErrorResponseContentToJSON,
    ListLoyaltyPromotions200ResponseFromJSON,
    ListLoyaltyPromotions200ResponseToJSON,
    ListPlayerActivity200ResponseFromJSON,
    ListPlayerActivity200ResponseToJSON,
    ListPlayerActivitySummary200ResponseFromJSON,
    ListPlayerActivitySummary200ResponseToJSON,
    Login200ResponseFromJSON,
    Login200ResponseToJSON,
    LoginRefresh200ResponseFromJSON,
    LoginRefresh200ResponseToJSON,
    LoginRefreshRequestContentFromJSON,
    LoginRefreshRequestContentToJSON,
    LoginRequestContentFromJSON,
    LoginRequestContentToJSON,
    NotAuthorizedErrorResponseContentFromJSON,
    NotAuthorizedErrorResponseContentToJSON,
    SearchPlayer200ResponseFromJSON,
    SearchPlayer200ResponseToJSON,
    SearchPlayerEmail200ResponseFromJSON,
    SearchPlayerEmail200ResponseToJSON,
    SearchPlayerEmailRequestContentFromJSON,
    SearchPlayerEmailRequestContentToJSON,
    SearchPlayerMobile200ResponseFromJSON,
    SearchPlayerMobile200ResponseToJSON,
    SearchPlayerMobileRequestContentFromJSON,
    SearchPlayerMobileRequestContentToJSON,
    SearchPlayerRequestContentFromJSON,
    SearchPlayerRequestContentToJSON,
    SetLoyaltyPointsRequestContentFromJSON,
    SetLoyaltyPointsRequestContentToJSON,
    SetPasLastViewed200ResponseFromJSON,
    SetPasLastViewed200ResponseToJSON,
    SetPlayerDetailsRequestContentFromJSON,
    SetPlayerDetailsRequestContentToJSON,
} from '../models';

export interface AddNoteRequest {
    addNoteRequestContent?: AddNoteRequestContent;
}

export interface CreatePlayerRequest {
    createPlayerRequestContent?: CreatePlayerRequestContent;
}

export interface CreatePlayerMobileRequest {
    createPlayerMobileRequestContent?: CreatePlayerMobileRequestContent;
}

export interface DecrementLoyaltyPointsRequest {
    decrementLoyaltyPointsRequestContent?: DecrementLoyaltyPointsRequestContent;
}

export interface DeleteNoteRequest {
    timestamp: string;
}








export interface IncrementLoyaltyPointsRequest {
    incrementLoyaltyPointsRequestContent?: IncrementLoyaltyPointsRequestContent;
}


export interface ListPlayerActivityRequest {
    startDate: string;
    endDate: string;
    offset: number;
    limit: number;
}


export interface LoginRequest {
    loginRequestContent?: LoginRequestContent;
}

export interface LoginRefreshRequest {
    loginRefreshRequestContent?: LoginRefreshRequestContent;
}

export interface SearchPlayerRequest {
    searchPlayerRequestContent?: SearchPlayerRequestContent;
}

export interface SearchPlayerEmailRequest {
    searchPlayerEmailRequestContent?: SearchPlayerEmailRequestContent;
}

export interface SearchPlayerMobileRequest {
    searchPlayerMobileRequestContent?: SearchPlayerMobileRequestContent;
}

export interface SetLoyaltyPointsRequest {
    setLoyaltyPointsRequestContent?: SetLoyaltyPointsRequestContent;
}


export interface SetPlayerDetailsRequest {
    setPlayerDetailsRequestContent?: SetPlayerDetailsRequestContent;
}

/**
 * 
 */
export class DefaultApi extends runtime.BaseAPI {
    /**
     * Adds a note to a player's account
     */
    async addNoteRaw(requestParameters: AddNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AddNote200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/player/notes`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: AddNoteRequestContentToJSON(requestParameters.addNoteRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AddNote200ResponseFromJSON(jsonValue));
    }

    /**
     * Adds a note to a player's account
     */
    async addNote(requestParameters: AddNoteRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AddNote200Response> {
        const response = await this.addNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new player in the Trac system with the provided details
     */
    async createPlayerRaw(requestParameters: CreatePlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePlayer200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/register`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePlayerRequestContentToJSON(requestParameters.createPlayerRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePlayer200ResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new player in the Trac system with the provided details
     */
    async createPlayer(requestParameters: CreatePlayerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePlayer200Response> {
        const response = await this.createPlayerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates a new player in the Trac system using only the mobile number
     */
    async createPlayerMobileRaw(requestParameters: CreatePlayerMobileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<CreatePlayerMobile200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/register/mobile`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: CreatePlayerMobileRequestContentToJSON(requestParameters.createPlayerMobileRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => CreatePlayerMobile200ResponseFromJSON(jsonValue));
    }

    /**
     * Creates a new player in the Trac system using only the mobile number
     */
    async createPlayerMobile(requestParameters: CreatePlayerMobileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<CreatePlayerMobile200Response> {
        const response = await this.createPlayerMobileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Decrements the loyalty points for the authenticated user
     */
    async decrementLoyaltyPointsRaw(requestParameters: DecrementLoyaltyPointsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenericSuccessResponseContent>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/points/decrement`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: DecrementLoyaltyPointsRequestContentToJSON(requestParameters.decrementLoyaltyPointsRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenericSuccessResponseContentFromJSON(jsonValue));
    }

    /**
     * Decrements the loyalty points for the authenticated user
     */
    async decrementLoyaltyPoints(requestParameters: DecrementLoyaltyPointsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenericSuccessResponseContent> {
        const response = await this.decrementLoyaltyPointsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes a note from a player's account
     */
    async deleteNoteRaw(requestParameters: DeleteNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<DeleteNote200Response>> {
        if (requestParameters.timestamp === null || requestParameters.timestamp === undefined) {
            throw new runtime.RequiredError('timestamp','Required parameter requestParameters.timestamp was null or undefined when calling deleteNote.');
        }

        const queryParameters: any = {};

        if (requestParameters.timestamp !== undefined) {
            queryParameters['timestamp'] = requestParameters.timestamp;
        }


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/player/notes`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => DeleteNote200ResponseFromJSON(jsonValue));
    }

    /**
     * Deletes a note from a player's account
     */
    async deleteNote(requestParameters: DeleteNoteRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<DeleteNote200Response> {
        const response = await this.deleteNoteRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets the billing information for all venues
     */
    async getBillingRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetBilling200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/billing`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetBilling200ResponseFromJSON(jsonValue));
    }

    /**
     * Gets the billing information for all venues
     */
    async getBilling(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetBilling200Response> {
        const response = await this.getBillingRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the current loyalty points for the authenticated user
     */
    async getLoyaltyPointsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetLoyaltyPoints200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/points`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetLoyaltyPoints200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the current loyalty points for the authenticated user
     */
    async getLoyaltyPoints(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetLoyaltyPoints200Response> {
        const response = await this.getLoyaltyPointsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves any notes associated with a player's account
     */
    async getNotesRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetNotes200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/player/notes`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetNotes200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves any notes associated with a player's account
     */
    async getNotes(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetNotes200Response> {
        const response = await this.getNotesRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the last viewed date of the Player Activity Statement data
     */
    async getPasLastViewedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPasLastViewed200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/player-activity-statement/last-viewed`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPasLastViewed200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the last viewed date of the Player Activity Statement data
     */
    async getPasLastViewed(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPasLastViewed200Response> {
        const response = await this.getPasLastViewedRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the Player Activity Statement data
     */
    async getPlayerActivityStatementRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPlayerActivityStatement200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/player-activity-statement`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPlayerActivityStatement200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the Player Activity Statement data
     */
    async getPlayerActivityStatement(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPlayerActivityStatement200Response> {
        const response = await this.getPlayerActivityStatementRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the Player Activity Statement PDF file
     */
    async getPlayerActivityStatementFileRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Blob>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/player-activity-statement/file`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.TextApiResponse(response) as any;
    }

    /**
     * Retrieves the Player Activity Statement PDF file
     */
    async getPlayerActivityStatementFile(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Blob> {
        const response = await this.getPlayerActivityStatementFileRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves the personal details of the authenticated user
     */
    async getPlayerDetailsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetPlayerDetails200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/player`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetPlayerDetails200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves the personal details of the authenticated user
     */
    async getPlayerDetails(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetPlayerDetails200Response> {
        const response = await this.getPlayerDetailsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Increments the loyalty points for the authenticated user
     */
    async incrementLoyaltyPointsRaw(requestParameters: IncrementLoyaltyPointsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenericSuccessResponseContent>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/points/increment`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IncrementLoyaltyPointsRequestContentToJSON(requestParameters.incrementLoyaltyPointsRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenericSuccessResponseContentFromJSON(jsonValue));
    }

    /**
     * Increments the loyalty points for the authenticated user
     */
    async incrementLoyaltyPoints(requestParameters: IncrementLoyaltyPointsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenericSuccessResponseContent> {
        const response = await this.incrementLoyaltyPointsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Lists all loyalty promotions available for the player
     */
    async listLoyaltyPromotionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListLoyaltyPromotions200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/promotions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListLoyaltyPromotions200ResponseFromJSON(jsonValue));
    }

    /**
     * Lists all loyalty promotions available for the player
     */
    async listLoyaltyPromotions(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListLoyaltyPromotions200Response> {
        const response = await this.listLoyaltyPromotionsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a list of player activity in batches. Batch size and offset can be controlled by the client
     */
    async listPlayerActivityRaw(requestParameters: ListPlayerActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPlayerActivity200Response>> {
        if (requestParameters.startDate === null || requestParameters.startDate === undefined) {
            throw new runtime.RequiredError('startDate','Required parameter requestParameters.startDate was null or undefined when calling listPlayerActivity.');
        }

        if (requestParameters.endDate === null || requestParameters.endDate === undefined) {
            throw new runtime.RequiredError('endDate','Required parameter requestParameters.endDate was null or undefined when calling listPlayerActivity.');
        }

        if (requestParameters.offset === null || requestParameters.offset === undefined) {
            throw new runtime.RequiredError('offset','Required parameter requestParameters.offset was null or undefined when calling listPlayerActivity.');
        }

        if (requestParameters.limit === null || requestParameters.limit === undefined) {
            throw new runtime.RequiredError('limit','Required parameter requestParameters.limit was null or undefined when calling listPlayerActivity.');
        }

        const queryParameters: any = {};

        if (requestParameters.startDate !== undefined) {
            queryParameters['startDate'] = requestParameters.startDate;
        }

        if (requestParameters.endDate !== undefined) {
            queryParameters['endDate'] = requestParameters.endDate;
        }

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/player/activity`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPlayerActivity200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a list of player activity in batches. Batch size and offset can be controlled by the client
     */
    async listPlayerActivity(requestParameters: ListPlayerActivityRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPlayerActivity200Response> {
        const response = await this.listPlayerActivityRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves a summarised list of "Visit Recaps" for a player
     */
    async listPlayerActivitySummaryRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ListPlayerActivitySummary200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/player/activity/summary`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ListPlayerActivitySummary200ResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves a summarised list of "Visit Recaps" for a player
     */
    async listPlayerActivitySummary(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ListPlayerActivitySummary200Response> {
        const response = await this.listPlayerActivitySummaryRaw(initOverrides);
        return await response.value();
    }

    /**
     * Authenticates a user with card number and surname
     */
    async loginRaw(requestParameters: LoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Login200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/login`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginRequestContentToJSON(requestParameters.loginRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => Login200ResponseFromJSON(jsonValue));
    }

    /**
     * Authenticates a user with card number and surname
     */
    async login(requestParameters: LoginRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Login200Response> {
        const response = await this.loginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Refreshes a user's login token
     */
    async loginRefreshRaw(requestParameters: LoginRefreshRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<LoginRefresh200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/login/refresh`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: LoginRefreshRequestContentToJSON(requestParameters.loginRefreshRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => LoginRefresh200ResponseFromJSON(jsonValue));
    }

    /**
     * Refreshes a user's login token
     */
    async loginRefresh(requestParameters: LoginRefreshRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<LoginRefresh200Response> {
        const response = await this.loginRefreshRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Searches the player list for matches against the first name, surname or player number
     */
    async searchPlayerRaw(requestParameters: SearchPlayerRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPlayer200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/search`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchPlayerRequestContentToJSON(requestParameters.searchPlayerRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPlayer200ResponseFromJSON(jsonValue));
    }

    /**
     * Searches the player list for matches against the first name, surname or player number
     */
    async searchPlayer(requestParameters: SearchPlayerRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPlayer200Response> {
        const response = await this.searchPlayerRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Searches the player list for matches against the email address
     */
    async searchPlayerEmailRaw(requestParameters: SearchPlayerEmailRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPlayerEmail200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/search/email`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchPlayerEmailRequestContentToJSON(requestParameters.searchPlayerEmailRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPlayerEmail200ResponseFromJSON(jsonValue));
    }

    /**
     * Searches the player list for matches against the email address
     */
    async searchPlayerEmail(requestParameters: SearchPlayerEmailRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPlayerEmail200Response> {
        const response = await this.searchPlayerEmailRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Searches the player list for matches against the mobile number
     */
    async searchPlayerMobileRaw(requestParameters: SearchPlayerMobileRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SearchPlayerMobile200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/search/mobile`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SearchPlayerMobileRequestContentToJSON(requestParameters.searchPlayerMobileRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SearchPlayerMobile200ResponseFromJSON(jsonValue));
    }

    /**
     * Searches the player list for matches against the mobile number
     */
    async searchPlayerMobile(requestParameters: SearchPlayerMobileRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SearchPlayerMobile200Response> {
        const response = await this.searchPlayerMobileRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Sets the current loyalty points for the authenticated user
     */
    async setLoyaltyPointsRaw(requestParameters: SetLoyaltyPointsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenericSuccessResponseContent>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/points`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SetLoyaltyPointsRequestContentToJSON(requestParameters.setLoyaltyPointsRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenericSuccessResponseContentFromJSON(jsonValue));
    }

    /**
     * Sets the current loyalty points for the authenticated user
     */
    async setLoyaltyPoints(requestParameters: SetLoyaltyPointsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenericSuccessResponseContent> {
        const response = await this.setLoyaltyPointsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Updates the last viewed date of the Player Activity Statement data to the current date & time
     */
    async setPasLastViewedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<SetPasLastViewed200Response>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};



        const response = await this.request({
            path: `/player-activity-statement/last-viewed`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SetPasLastViewed200ResponseFromJSON(jsonValue));
    }

    /**
     * Updates the last viewed date of the Player Activity Statement data to the current date & time
     */
    async setPasLastViewed(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<SetPasLastViewed200Response> {
        const response = await this.setPasLastViewedRaw(initOverrides);
        return await response.value();
    }

    /**
     * Updates the personal details of the authenticated user
     */
    async setPlayerDetailsRaw(requestParameters: SetPlayerDetailsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GenericSuccessResponseContent>> {
        const queryParameters: any = {};


        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        const response = await this.request({
            path: `/player`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: SetPlayerDetailsRequestContentToJSON(requestParameters.setPlayerDetailsRequestContent),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GenericSuccessResponseContentFromJSON(jsonValue));
    }

    /**
     * Updates the personal details of the authenticated user
     */
    async setPlayerDetails(requestParameters: SetPlayerDetailsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GenericSuccessResponseContent> {
        const response = await this.setPlayerDetailsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}

